export default __webpack_public_path__ + "static/trello-b0554c6887dcf1a1b3c0b7e78889b924.gif";